/**
 * worklist-config-modal.component.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DialogRef, ModalComponent } from "angular2-modal";
import { BSModalContext } from "angular2-modal/plugins/bootstrap";
import { Observable } from "rxjs/Rx";

export interface WorklistConfigModalContext extends BSModalContext
{
  columns : string[];
  hidden? : string[];
}

const IMPORT_VERSION : number = 2;

@Component({
  template: `
  <div class="modal-header">
    <button
      type="button"
      class="close"
      (click)="dialog.dismiss()"
      aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">
      Configure Worklist Display
    </h4>
  </div>
  <div class="modal-body">
    <!-- <h3 class="debug-only">Caution!</h3> -->
    <p>
      You can hide columns by selecting them in the box below.
    </p>
    <p>
      Note that this setting is saved on your machine. If you log in from
      another computer or clear your browser's data, it will not be maintained.
    </p>
    <div class="form-group">
      <label>
        Hidden Columns
        <small>Use <kbd>Ctrl</kbd> or <kbd>Cmd</kbd> to select multiple.</small>
      </label>
      <select multiple class="form-control" [formControl]="hidden" size="16">
        <option *ngFor="let col of dialog.context.columns" [ngValue]="col">
          {{col}}
        </option>
      </select>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-default"
      (click)="dialog.dismiss()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-danger"
      (click)="clear()">
      Clear
    </button>
    <button
      type="button"
      class="btn btn-warning"
      (click)="submit()">
      Save
    </button>
  </div>
  `,
  styles: [
    "/deep/ prettyjson pre {outline: none !important;}",
    "/deep/ #sendButton {position: relative; top: -8px;}"
  ]
})
export class WorklistConfigModalComponent
  implements ModalComponent<WorklistConfigModalContext>, OnInit
{
  public hidden : FormControl = new FormControl([]);

  constructor (
    public dialog : DialogRef<WorklistConfigModalContext>
  ) { /* DI */ }

  public ngOnInit () : void
  {
    if (Array.isArray(this.dialog.context.hidden))
    {
      this.hidden.setValue(this.dialog.context.hidden);
    }
  }

  public submit () : void
  {
    this.dialog.close(this.hidden.value);
  }

  public clear () : void
  {
    this.dialog.close([]);
  }

  public tryAnswering (answers : Array<[number, any]>) : void
  {
    // mock receive updates
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/watchlists/worklist-config-modal.component.ts